import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseTypeCheck } from 'src/app/enumeration/response-type';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiCallServiceService {
  // 1. Cleaned up constructor: Removed Router and DataStoreService since the interceptor manages them now
  constructor(private http: HttpClient) {}

  getApiCall(
    url: string,
    responseType: string,
    contentType: string,
  ): Observable<any> {
    const httpOptions = this.getHeaders(responseType, contentType);
    return this.http.get<any>(environment.baseUrl + url, httpOptions);
  }

  postApiCall(
    url: string,
    body: any,
    responseType: string,
    contentType: string,
  ): Observable<any> {
    const httpOptions = this.getHeaders(responseType, contentType);
    return this.http.post<any>(environment.baseUrl + url, body, httpOptions);
  }

  refreshTokenApiCall()                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    : Observable<any> {
    // 2. SECURITY FIX: Removed manual Authorization header.
    // The authInterceptor handles cookies automatically during this call.
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(
      environment.baseUrl + 'api/rwadmin/refreshtoken',
      null,
      { headers }
    );
  }

  // 3. ARCHITECTURE CLEANUP: Handled Accept header and type options cleanly
  private getHeaders(isText: string, isContentType: string): any {
    let headers = new HttpHeaders({
      Accept: 'application/json',
    });

    if (isContentType === ResponseTypeCheck.CONT_JSON) {
      headers = headers.set('Content-Type', 'application/json');
    }

    let responseType: 'json' | 'text' | 'arraybuffer' = 'json';
    if (isText === ResponseTypeCheck.TEXT) {
      responseType = 'text';
    } else if (isText === ResponseTypeCheck.ARRAY_BUFFER) {
      responseType = 'arraybuffer';
    }

    // Notice: withCredentials is gone from here. It is applied globally by the interceptor.
    return { headers, responseType };
  }
}
